import { SelectBundler } from './SelectBundler';
import { Submit } from './Submit';

interface Store {
  config: {
    locale: string;
    submitBaseUrl: string;
    selectorName: {
      bundler: string;
      btn: string;
      input: string;
      submit: string;
    };
    className: {
      activeSelectBtn: string;
      activeSelectInput: string;
    };
    msg: {
      validError: string;
    };
  };
  state: {
    start: string;
    end: string;
  };
}

export default class Gmap2PointLinkCreateUI {
  private node: HTMLElement;
  private store: Store;

  constructor({ appSelector, locale = 'ja' }: { appSelector: string; locale?: string }) {
    this.store = {
      config: {
        locale,
        submitBaseUrl: 'https://www.google.co.jp/maps/dir/',
        selectorName: {
          bundler: '[data-mp-role="gmap-2point-link-create-ui-bundler"]',
          btn: '[data-mp-role="gmap-2point-link-create-ui-btn"]',
          input: '[data-mp-role="gmap-2point-link-create-ui-input"]',
          submit: '[data-mp-role="gmap-2point-link-create-ui-submit"]',
        },
        className: {
          activeSelectBtn: 'is-active',
          activeSelectInput: 'is-active',
        },
        msg: {
          validError: '出発地点と選択地点の両方を選択してください',
        },
      },
      state: {
        start: '',
        end: '',
      },
    };

    const node = document.querySelector(appSelector);
    if (!node) return;

    this.node = node as HTMLElement;

    new Submit({
      node: this.node.querySelector(this.store.config.selectorName.submit) as HTMLElement,
      store: this.store,
    });

    this.node.querySelectorAll(this.store.config.selectorName.bundler).forEach((node) => {
      new SelectBundler({
        node: node as HTMLElement,
        store: this.store,
        type: (node as HTMLElement).dataset.mpBundleType as 'start' | 'end',
      });
    });
  }
}
